import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 sm:gap-4 mt-2 sm:mt-4" }
const _hoisted_2 = { class: "flex items-center gap-2 max-w-xs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "text-white text-sm whitespace-nowrap"
}, "PostID :", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "text-white text-sm whitespace-nowrap"
}, "Source :", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "mt-2 sm:mt-4 grid grid-cols-[repeat(auto-fill,_minmax(8rem,_1fr))] gap-2 sm:gap-4" }
const _hoisted_9 = { class: "flex gap-2 mt-2 sm:mt-4" }

import { createVNode, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Button, Modal } from 'ant-design-vue';
import { DeleteFilled, DeleteOutlined } from '@ant-design/icons-vue';
import DropFile from '@/components/shared/DropFile.vue';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue';
import { File as DocumentFile, DocumentType } from '@/model/document';
import { deleteDocument, getDocumentDetail, updateDocument } from '@/repository/document';
import { capitalize } from '@/util/universal';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateDocument',
  props: {
    documentType: {},
    metadataID: {},
    documentUUID: {}
  },
  setup(__props: any) {

const props = __props;



const router = useRouter();
const store = useStore();

const source = ref('');
const subID = ref('');
const isLoading = ref(true);
const files = ref<File[]>([]);
const initFiles = ref<DocumentFile[]>([]);
const deleteFileIDs = ref<string[]>([]);

const fileContent = (file: File) => URL.createObjectURL(file);
const selectImages = (selectFiles: File[]) => selectFiles.forEach((file) => files.value.push(file));
const removeImage = (img: { index?: number; id?: string }) => {
	if (img.id !== undefined) {
		deleteFileIDs.value.push(img.id);
	} else if (img.index !== undefined) {
		files.value = files.value.filter((_, idx) => img.index !== idx);
	}
};

init();
async function init() {
	const res = await getDocumentDetail(props.documentUUID);
	if (res) {
		subID.value = res.subID;
		source.value = res.source;
		initFiles.value = res.files;
		isLoading.value = false;
	} else {
		await router.push(`/${props.documentType}/${props.metadataID}`);
	}
}

function clear() {
	files.value = [];
	deleteFileIDs.value = [];
}

async function submit() {
	if (deleteFileIDs.value.length === initFiles.value.length && !files.value.length) {
		Modal.confirm({
			title: `Delete ${capitalize(String(props.documentType), ' ')}`,
			icon: createVNode(DeleteFilled),
			content: `Do you want to delete all ${deleteFileIDs.value.length} ${props.documentType}${deleteFileIDs.value.length > 1 && props.documentType !== DocumentType.Onlyfans ? 's' : ''} right?`,
			okText: 'Yes',
			cancelText: 'No',
			async onOk() {
				await deleteDocument(props.documentUUID);
				await router.push(`/${props.documentType}/${props.metadataID}`);
				store.dispatch('alert', {
					type: 'success',
					message: `delete ${props.documentType} successfully!`
				});
			}
		});
		return;
	}
	try {
		isLoading.value = true;
		const res = await updateDocument(props.documentUUID, deleteFileIDs.value, files.value);
		if (res.data) {
			store.dispatch('alert', {
				type: 'success',
				message: `update ${props.documentType} successfully!`
			});
			await router.push(`/${props.documentType}/${props.metadataID}`);
			return;
		}
		throw res.error?.error;
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: error ?? 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(SpinnerLoading, { loading: isLoading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("input", {
            value: subID.value,
            placeholder: "Enter ${props.documentType} id",
            class: "px-2 text-sm w-full h-8 rounded-md bg-white cursor-not-allowed border-none",
            disabled: ""
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("input", {
            value: source.value,
            placeholder: "Enter ${props.documentType} source",
            class: "px-2 text-sm w-56 h-8 rounded-md bg-white cursor-not-allowed border-none",
            disabled: ""
          }, null, 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(DropFile, { onSelect: selectImages }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(initFiles.value?.filter((file) => !deleteFileIDs.value.includes(file.id)), (file, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "relative min-w-[8rem] min-h-[8rem] aspect-square"
          }, [
            _createVNode(ImageLoading, {
              src: file.thumbnailURL,
              previewable: true,
              "img-class": "!h-full !w-full aspect-square",
              "loading-class": "h-full w-full m-auto sm:m-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  onClick: ($event: any) => (removeImage({ id: file.id })),
                  class: "bg-red-400 border-none hover:!text-white rounded-full absolute top-1 right-1"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(DeleteOutlined))
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1032, ["src"])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "relative min-w-[8rem] min-h-[8rem] aspect-square"
          }, [
            _createVNode(ImageLoading, {
              src: fileContent(file),
              previewable: true,
              "img-class": "!h-full !w-full aspect-square",
              "loading-class": "h-full w-full m-auto sm:m-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  onClick: ($event: any) => (removeImage({ index })),
                  class: "bg-red-400 border-none hover:!text-white rounded-full absolute top-0 right-0"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(DeleteOutlined))
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1032, ["src"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(Button), {
          "html-type": "reset",
          onClick: clear
        }, {
          default: _withCtx(() => [
            _createTextVNode("Reset")
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          "html-type": "submit",
          type: "primary",
          class: "disabled",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode("Submit")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})